import type { ReactNode } from "react";
import { useGetIdentity } from "@refinedev/core";
import { canAccess } from "@/providers/accessControlProvider";
import type { AdminIdentity } from "@/providers/types";
import { useT } from "@/i18n/useT";
import { NoPermission } from "./NoPermission";

export type PicksGuardResource =
  | "picks"
  | "picks-partners"
  | "picks-categories";

interface RouteGuardProps {
  resource: PicksGuardResource;
  action: "list" | "show" | "edit";
  children: ReactNode;
}

export function RouteGuard({ resource, action, children }: RouteGuardProps) {
  const { t } = useT();
  const { data: identity, isLoading } = useGetIdentity<AdminIdentity>();

  if (isLoading === true && identity === undefined) {
    return (
      <p role="status" aria-busy="true" className="p-6 text-[var(--muted)]">
        {t("shell.loading")}
      </p>
    );
  }

  const decision = canAccess({
    resource,
    action,
    role: identity?.role,
  });
  if (!decision.can) return <NoPermission />;
  return <>{children}</>;
}
